import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IAvailabilityWindowSchema, WeekDay } from 'common-lib';
import * as _ from 'lodash';

interface ICalendarTimeRanges {
    availabilityWindows: IAvailabilityWindowSchema;
    weekday: WeekDay;
}

@Injectable({ providedIn: 'root' })
export class TimeRangeService {
    private readonly _timeRanges = new BehaviorSubject<ICalendarTimeRanges>(null);
    readonly timeRanges$: Observable<ICalendarTimeRanges> = this._timeRanges.asObservable();

    constructor() {}

    set timeRanges(updatedWindow: { availabilityWindows: IAvailabilityWindowSchema; weekday: WeekDay }) {
        this._timeRanges.next(updatedWindow);
    }

    public updateTimeRanges(availabilityWindows: IAvailabilityWindowSchema, weekday: WeekDay) {
        this.timeRanges = {
            availabilityWindows,
            weekday
        };
    }
}
